

import { useLocation, useNavigate } from "react-router-dom";

import {
validateToken,
SessionManager,
sessionService,
} from '../components/ComponentsLibrary'


const updateTokenValidationInSession = async (tokenValid) => {
  sessionService.updateUser({ isTokenValidated: tokenValid, });
};

function ValidateTokenFromIDP(configLibrary, navigate) {  

  if (sessionStorage.getItem("token")) {
    let tokenValidation = validateToken(sessionStorage.getItem("token"), configLibrary);
    
    if (tokenValidation === true) {
      updateTokenValidationInSession(true);
     
      if (!sessionStorage.getItem("isSiteSelected")) {
       
        //navigate('/siteselect');
        window.location.replace('/siteselect');
        sessionStorage.setItem("isSiteSelected", true);
       
      }
    }
    else if (tokenValidation === undefined) {
      SessionManager.ClearSession();
      window.location.replace("/");
      //window.location.replace(configLibrary.b2cUrl);
      //window.open(configLibrary.b2cUrl, "_self");
    }
    else {
      SessionManager.ClearSession();
      
      alert(tokenValidation);
      window.location.replace("/");
      //window.location.replace(configLibrary.b2cUrl);
      //window.open(configLibrary.b2cUrl, "_self");
    }
  }
  else {
    SessionManager.ClearSession();
    window.location.replace("/");
    //window.location.replace(configLibrary.b2cUrl);
    //window.open(configLibrary.b2cUrl, "_self");
  }
};


  // Validate date - not empty and valid format
  const ValidateDate = (dateString) => {
    let hasDate = true;
    let validDate = true;
    let validYear = true;
    let validYearMessage = "";

    if (!dateString) {
      hasDate = false;
    }

    // Check if the date is valid
    const dateObj = new Date(dateString);
    if (isNaN(dateObj.getTime())) {
      validDate = false;
    }

    const enteredYear = dateObj.getFullYear();
    const currentYear = new Date().getFullYear();
    if (enteredYear < 2000 || enteredYear > currentYear) {
      validYear = false;
      validYearMessage = "Year must be entered between 2000 and " + currentYear;
    }

    return { hasDateValue: hasDate, validDateValue: validDate, validYearValue: validYear, validYearMessage: validYearMessage };
  };

  const ValidateStartDate = (startDate, endDate) => {
    let hasValidData = false;
    let validationMessage = '';
    const { hasDateValue, validDateValue, validYearValue, validYearMessage } = ValidateDate(startDate);

    if (!hasDateValue) {
      validationMessage = 'Start date is required. Please enter a valid date and search again';
    }
    else if (!validDateValue) {
      validationMessage = 'Please enter a valid date and search again';
    }
    else if (!validYearValue) {
        validationMessage = validYearMessage;
    }
    else if (startDate && endDate && startDate > endDate) {
      validationMessage = 'Start date must be on or before end date';
    }
    else {
      hasValidData = true;
      validationMessage = '';
    }

    return { hasValidData: hasValidData, validationMessage: validationMessage };
  };

  const ValidateEndDate = (startDate, endDate) => {
    let hasValidData = false;
    let validationMessage = '';
    const { hasDateValue, validDateValue, validYearValue, validYearMessage } = ValidateDate(endDate);

    if (!hasDateValue) {
      validationMessage = 'End date is required. Please enter a valid date and search again';
    }
    else if (!validDateValue) {
      validationMessage = 'Please enter a valid date and search again';
    }
    else if (!validYearValue) {
        validationMessage = validYearMessage;
    }
    else if (endDate && startDate && endDate < startDate) {
      validationMessage = 'End date must be on or after start date';
    }
    else {
      hasValidData = true;
      validationMessage = '';
    }

    return { hasValidData: hasValidData, validationMessage: validationMessage };
  };


const ValidationUtility = {
  ValidateTokenFromIDP,
  ValidateDate,
  ValidateStartDate,
  ValidateEndDate,

};
  
  export default ValidationUtility;